const {
	base_path,
	base_path_portal,
	base_path_api, 
	base_path_caja,
	base_path_resources,
	anteater_url, 
	gtm_code,
	path_yotpo,
	hidden_discount,
	envio_gratis,
	products_per_pagination,
	stage_dirname,
	api_exception,
	base_path_t1,
	jwt1,
	variants
} = window["runConfigCreditSite"]

const {
	keyC
} = window["runConfig"]


export const ROUTE = ['/', 'consultar-saldo','newHome']
export const ROUTE_PAGOS_EXPRESS = ['pagar-tarjeta','elegir-tarjeta','agregar-tarjeta-bancaria','thakYouPage']


export const PORTAL_URL = ""
export const BASE_PATH = base_path
export const SUB_DIRECTORY = "Credito-Sears/"
export const BASE_PATH_PORTAL = base_path_portal
export const BASE_PATH_API = base_path_api
export const BASE_PATH_CAJA = base_path_caja
export const BASE_PATH_T1 = base_path_t1
export const BASE_PATH_RESOURCES = base_path_resources

export const ACCESS_TOKEN_ROUTE = "access_token_Sears"

export const STAGE = "Sears"

export const STAGE_PORTAL = "Salesforce-1"
export const DOMAIN_SF = 'https://slim-stg-sears.mobify-storefront.com'
export const REDIRECT_URI = encodeURIComponent(`${DOMAIN_SF}/callback`)
export const STAGE_SF = 'f_ecom_bljk_stg'
export const CLIENT_ID_SF = 'a148b931-d67b-4d23-bbf8-6eae1448d5f9'
export const SITE_ID = 'Sears'


export const BASE_PATH_API_DEV = api_exception
export const STAGE_DIRNAME = stage_dirname
export const VARIANTS_PER_PORTAL = variants
export const JWT1 = jwt1
export const MERCHANT_ID = "decompras_sears"


export const URL_SERVICIO = `/c/servicio-tecnico/`;
export const GTM_CODE = gtm_code

export const ANTEATER_URL = anteater_url
export const PATH_YOTPO = path_yotpo

export const NO_IMAGE = `${BASE_PATH_RESOURCES}/medios-plazavip/swift/v1/assets/img/noImage.png`

export const MENU_PORTAL =  `${BASE_PATH_API}producto/categoria`

export const SEARCH_ANTEATER = `${ANTEATER_URL}/search`
export const SEARCH_AUTOCOMPLETE = `${ANTEATER_URL}/autocompletar?cliente=sears`
export const STAR_YOTPO = `${PATH_YOTPO}/v1/widget/UmGRN4SZ2WasPZ38vf5bskYT82P9nN4fLYRwxpXD/products`

export const HIDDEN_DISCOUNT = hidden_discount
export const ENVIO_GRATIS = envio_gratis
export const PRODUCTS_PER_PAGINATION = products_per_pagination
export const TIMEOUT_TIME = 25000
export const SSO = keyC;